import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../components/MessageBox/MessageBox";
import Paper from "@material-ui/core/Paper";
import NumberFormat from "react-number-format";
import { findIndex } from "lodash/array";
import LoadingOverlay from "react-loading-overlay";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import FranchiseModal from "./FranchiseModal";
import { Box } from "@material-ui/core";
import numeral from "numeral";
import PopUpModal from "../../components/Modal/PopUpModal";
const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: 0,
  },
  field: {
    width: "100%",
    marginBottom: "1rem",
  },
  autoComplete: {
    width: "100%",
    marginTop: "0",
    marginBottom: "0.5rem",
  },
  date: {
    width: "100%",
    marginBottom: "1rem",
  },
  buttonContainer: {
    textAlign: "right",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  button: {
    textAlign: "right",
    marginTop: "30px",
    "& .MuiButton-containedPrimary": {
      marginRight: "10px",
    },
  },

  buttonMarginRight: {
    marginRight: "0.5rem",
  },

  paper: {
    background: "#339933",
    width: "100%",
    height: "auto",
  },
  formlabelpayment: {
    color: "white",
  },
}));

const FranchisePayment = (props) => {
  const classes = useStyles();
  const packageInfo = props.location.packageInfo || {};
  const navid = props.location.pageInfo ? props.location.pageInfo.navid : 0;
  const from = props.location.from ? props.location.from : "";
  const CurrentPage = props.location.pageInfo
    ? props.location.pageInfo.navname
    : "";
  const TransactionInformation = props.location.transactionInfo
    ? props.location.transactionInfo
    : "";
  const PackageSalesInformation = props.location.selectedpackagesInfo
    ? props.location.selectedpackagesInfo
    : "";
  const ItemsInformation = props.location.selectedItemsInfo
    ? props.location.selectedItemsInfo
    : "";
  const ExcessPriceInfo = props.location.excessPriceInfo
    ? props.location.excessPriceInfo
    : 0;
  const GeneratedActivationcardsInfo = props.location
    .generatedActivationcardsInfo
    ? props.location.generatedActivationcardsInfo
    : "";
  const notesInfo = props.location.notesInfo ? props.location.notesInfo : "";
  const isBranch = props.location.isBranch ? props.location.isBranch : "no";
  const packagechosen = props.location.selectedpackagesInfo
    ? props.location.selectedpackagesInfo
    : props.location.packagechosen;

  const [packagePrice, setPackagePrice] = useState(packageInfo.package_amount);
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [branchCurcode, setBranchCurcode] = useState(get_cookies("curcode"));
  const [userName, setUserName] = useState(get_cookies("username"));
  const [saveFunction, setSaveFunction] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("info");
  const [popUpMessage, setPopUpMessage] = useState("");
  const [defaultPayment, setDefaultPayment] = useState({
    id: 0,
    description: "Select Payment",
    status: 0,
    clearing: "none",
  });
  const [clearPayment, setClearPayment] = useState({
    id: 0,
    description: "Select Payment",
    status: 0,
    clearing: "none",
  });
  //Loading overlay
  const [showOverlay, setShowOverlay] = useState(false);
  const [overLayMsg, setOverlayMsg] = useState(false);
  //Loading overlay EOF
  const [isSaveBtnDisabled, setSaveBtnDisabled] = useState(false);
  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF
  const [showSavedModal, setShowSavedModal] = useState(false);
  const [propModal, setPropModal] = useState([
    "/wholesale-transaction-history/",
    "Wholesale Transaction History",
  ]);
  const [iscodesOnly, setIsCodesOnly] = useState(false);
  const headers = {
    "Content-Type": "multipart/form-data",
  };
  //ApiData Component useState SOF
  const [payment_list, loadPaymentDropDown] = useState([]);
  const get_paymentlist = () => {
    //get data for warehouse/location dropdown
    const formData = new FormData();
    formData.append("form_data", get_cookies("branchidno"));
    const apiUrl = process.env.REACT_APP_API_URL + "payment_list";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPaymentDropDown(res.data.payment_list);
      // console.log('peayment',res.data.payment_list)
    });
  };
  const get_package_price = () => {
    // console.log("12", props.location.packageInfo);
    props.location.packageInfo.franchise_price == null
      ? setPackagePrice(props.location.packageInfo.franchise_price)
      : setPackagePrice(props.location.packageInfo.franchise_price);
  };

  //   const get_save_function = () => {
  //     if (isBranch == "set") {
  //       setSaveFunction("savebranchpackagepurchaseset");
  //     } else if (isBranch == "promo") {
  //       setSaveFunction("savebranchpackagepurchasepromo");
  //     } else {
  //       const form_data = {
  //         navid: navid,
  //       };
  //       const formData = new FormData();
  //       formData.append("form_data", JSON.stringify(form_data));
  //       const apiUrl = process.env.REACT_APP_API_URL + "save_function";
  //       axios.post(apiUrl, formData, { headers: headers }).then((res) => {
  //         if (res.data.success == 1) {
  //           setSaveFunction(res.data.save_function.save_function);
  //         } else {
  //           setShowMsgBox(true);
  //           setMsg("Missing navigation ID");
  //           setMsgType("warning");
  //           setTimeout(() => {
  //             setShowMsgBox(false);
  //           }, 3000);
  //         }
  //       });
  //     }
  //   };
  const save_package = () => {
    setSaveBtnDisabled(true);
    const form_data = {
      navid: navid,
      transactioninfo: TransactionInformation,
      package_info: props.location.packageInfo,
      items_info: ItemsInformation,
      generatedIdsinfo: GeneratedActivationcardsInfo,
      payment_info: TABLE_DATA,
      hqidno: branchIdNo,
      username: userName,
      notesinfo: notesInfo,
      packagechosen: packagechosen,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    setSaveBtnDisabled(true);
    setShowOverlay(true);
    setOverlayMsg("Processing Payment...");
    //     if (saveFunction == "" || saveFunction == null) {
    //       setShowMsgBox(true);
    //       setMsg(
    //         "Transaction cannot be completed, Due to Module still under development"
    //       );
    //       setMsgType("warning");
    //       setTimeout(() => {
    //         setShowMsgBox(false);
    //         setShowOverlay(false);
    //         setOverlayMsg("");
    //       }, 3000);
    //       setSaveBtnDisabled(false);
    //     } else {
    if (
      parseFloat(computedPayment.total_payment) <
      parseFloat(computedPayment.topay_amount) +
        parseFloat(computedPayment.shipping_amount)
    ) {
      setPopUpMessage("Insufficient Payment");
      setModalOpen(true);
      setMessageType("warning");
      // setShowMsgBox(true);
      // setMsg("Insufficient Payment");
      // setMsgType("warning");
      setTimeout(() => {
        setModalOpen(false);
        setShowOverlay(false);
        setOverlayMsg("");
      }, 3000);
      setSaveBtnDisabled(false);
    } else {
      const apiUrl =
        isBranch == "promo"
          ? process.env.REACT_APP_API_URL + "save_wholesale_promo"
          : process.env.REACT_APP_API_URL + "save_franchise";
      axios.post(apiUrl, formData, { headers: headers }).then((res) => {
        if (res.data.result.successful == 1) {
          setTimeout(() => {
            setShowOverlay(false);
            setOverlayMsg("");
            setShowSavedModal(true);
            setPropModal([
              "/wholesale-transaction-history/",
              "Wholesale Set Transaction History",
            ]);
          }, 3000);
        } else {
          setPopUpMessage(res.data.result.message);
          setModalOpen(true);
          setMessageType("warning");
          // setShowMsgBox(true);
          // setMsg(res.data.result.message);
          // setMsgType("warning");
          setTimeout(() => {
            setModalOpen(false);
            setShowOverlay(false);
            setOverlayMsg("");
          }, 3000);
        }
      });
    }
  };
  useEffect(() => {
    // console.log("props", props);
    const newData = { ...computedPayment };
    if (ExcessPriceInfo > 0) {
      newData["topay_amount"] =
        parseFloat(packagePrice) + parseFloat(ExcessPriceInfo);
    } else {
      newData["topay_amount"] = packagePrice;
    }
    newData["shipping_amount"] = TransactionInformation.shippingcharge;
    newData["total_balance"] =
      parseFloat(packagePrice) + parseFloat(TransactionInformation.shippingcharge);
    setComputedPayment({ ...newData });
  }, [packagePrice]);
  //ApiData Component useState EOF

  //Table Settings
  const [TABLE_DATA, setSelectedPaymentTable] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState({});
  const [computedPayment, setComputedPayment] = useState({});
  const onSelectPayment = () => {
    let newData = [...TABLE_DATA];

    const neededKeys = ["payamount", "paymentid"];

    if (neededKeys.every((key) => Object.keys(selectedPayment).includes(key))) {
      let tempObj;
      if (selectedPayment.paymentname == "Cash") {
        tempObj = {
          paymentid: selectedPayment.paymentid,
          paymentname: selectedPayment.paymentname,
          payamount: selectedPayment.payamount,
          payref: selectedPayment.payref,
        };
      } else {
        tempObj = {
          paymentid: selectedPayment.paymentid,
          paymentname: selectedPayment.paymentname,
          payamount: selectedPayment.payamount,
          payref: selectedPayment.payref,
        };
      }

      if (
        selectedPayment.paymentid == "" ||
        selectedPayment.payamount == "" ||
        selectedPayment.payamount == 0 ||
        selectedPayment.payref == "" ||
        selectedPayment.payref == null ||
        selectedPayment.paymentid == null
      ) {
        setPopUpMessage("Please complete all required fields");
        setModalOpen(true);
        setMessageType("warning");
        // setShowMsgBox(true);
        // setMsg("Please complete all required fields");
        // setMsgType("warning");
        setTimeout(() => {
          setModalOpen(false);
        }, 3000);
      } else {
        let amttoadd =
          Number(computedPayment.total_payment) +
          Number(selectedPayment.payamount);
        if (
          Number(amttoadd) >
          Number(computedPayment.topay_amount) +
            Number(computedPayment.shipping_amount)
        ) {
          setPopUpMessage("Payment is greater than to the amount to be settle");
          setModalOpen(true);
          setMessageType("warning");
          // setShowMsgBox(true);
          // setMsg("Payment is greater than to the amount to be settle");
          // setMsgType("warning");
          setTimeout(() => {
            setModalOpen(false);
          }, 3000);
        } else {
          addOrUpdate(newData, tempObj);
          clear_fields();
        }
      }
    } else {
      setPopUpMessage("Please complete all required fields");
      setModalOpen(true);
      setMessageType("warning");
      // setShowMsgBox(true);
      // setMsg("Please complete all required fields");
      // setMsgType("warning");
      setTimeout(() => {
        setModalOpen(false);
      }, 3000);
    }
  };

  const does_have_free_inventory = () => {
    if (ExcessPriceInfo > 0) {
      let newData = [...TABLE_DATA];
      const tempObj = {
        paymentid: 13,
        paymentname: "Free Inventory",
        payamount: ExcessPriceInfo.toFixed(2),
        payref: "Free Inventory",
      };
      addOrUpdate(newData, tempObj);
    }
  };

  //Callback function of onSelectPayment
  useEffect(() => {
    computePayment();
  }, [TABLE_DATA]);

  const addOrUpdate = (array, item) => {
    const i = array.findIndex((_item) => _item.paymentid === item.paymentid);
    if (i > -1) {
      array[i].payamount =
        parseFloat(array[i].payamount) + parseFloat(item.payamount);
      array[i].payref = item.payref;
      computePayment();
    } else {
      array.push(item);
      setSelectedPaymentTable([...array]);
    }
  };

  const onInputChange = (event) => {
    if (!event.target.value.trim().length) {
      // only white-spaces
      const newData = { ...selectedPayment };
      newData[event.target.name] = "";
      setSelectedPayment({ ...newData });
    } else {
      const newData = { ...selectedPayment };
      newData[event.target.name] = event.target.value;
      setSelectedPayment({ ...newData });
    }
  };

  const computePayment = () => {
    let total_payment = 0;
    for (let index = 0; index < TABLE_DATA.length; index++) {
      total_payment =
        parseFloat(total_payment) + parseFloat(TABLE_DATA[index].payamount);
    }
    const newData = { ...computedPayment };
    const total_balance =
      parseFloat(computedPayment.topay_amount) +
      parseFloat(computedPayment.shipping_amount) -
      parseFloat(total_payment);
    newData["total_payment"] = total_payment;
    newData["total_balance"] = total_balance;
    setComputedPayment({ ...newData });
  };

  const refreshTable = () => {
    const newData = [...TABLE_DATA];
    setSelectedPaymentTable([...newData]);
  };

  const TABLE_COLUMNS = [
    {
      name: "paymentid",
      label: "ID",
    },
    {
      name: "paymentname",
      label: "Payment Type",
    },
    {
      name: "payamount",
      label: "Amount",
    },
    {
      name: "payref",
      label: "Reference",
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          return (
            <Button
              sx={{
                backgroundColor: "red",
                "&:hover": { backgroundColor: "red" },
              }}
              variant="contained"
              color="secondary"
              onClick={() => updateSelectedPayment(rowIndex)}
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  const TABLE_OPTION = {
    selectableRowsHideCheckboxes: true,
    // selectableRowsOnClick: true,
    print: false,
    filter: false,
    download: false,
    viewColumns: false,
    // onRowsDelete: (data) => {
    //   updateSelectedPayment(data.data[0].dataIndex);
    // },
  };

  const updateSelectedPayment = (index) => {
    TABLE_DATA.splice(index, 1);
    refreshTable();
  };

  const blockEvent = (e) => {
    e.preventDefault();
  };
  //Table Settings EOF

  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    isLoggedIn();
    get_paymentlist();
    get_package_price();
    //     get_save_function();
    //     does_have_free_inventory();
    const newData = { ...computedPayment };
    newData["topay_amount"] = packageInfo.package_amount;
    newData["total_payment"] = 0;
    newData["shipping_amount"] = 0;
    newData["total_balance"] = 0;
    setComputedPayment({ ...newData });
  }, []);
  //OnLoad Event/Data Fetching SOF

  //Api Functions SOF
  // Code blocks here
  //Api Request Functions EOF

  const dropDownPaymentList = {
    options: payment_list,
    getOptionLabel: (option) => option.description,
  };
  const numericOnly = (event) => {
    var regex = /^\d*\.?\d*$/;
    let x = "";
    if (regex.test(event.target.value)) {
      x = event.target.value;
    } else {
      x = "";
    }
    const y = x.replaceAll("-", "");
    const newData = { ...selectedPayment };
    newData[event.target.name] = y;
    setSelectedPayment({ ...newData });
  };

  const NumberKeyTrapper = (e) => {
    var a = [];
    var k = e.which;

    for (let i = 48; i < 58; i++) {
      a.push(i);
    }

    if (!(a.indexOf(k) >= 0)) {
      e.preventDefault();
    }
  };

  const clear_fields = () => {
    const newData = { ...selectedPayment };
    newData["paymentid"] = "";
    newData["paymentname"] = "";
    newData["payamount"] = "";
    newData["payref"] = "";
    setSelectedPayment({ ...newData });
    setDefaultPayment(clearPayment);
  };

  const packagesales_home = {
    pathname: "/Franchise",
  };
  const gobacktoHomepage = () => {
    props.history.push(packagesales_home);
  };
  //FormData
  const [prep_data, setData] = useState({});
  //FormData EOF

  return (
    <div className="page">
      <PopUpModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        message={popUpMessage}
        type={messageType}
      />
      <LoadingOverlay active={showOverlay} spinner text={overLayMsg}>
        <div className="page-header">
          <div className="page-icon">
            <ShoppingCartIcon />
          </div>

            <Breadcrumbs aria-label="breadcrumb">
              <NavLink to="/Wholesale">
                <h2 className="header-title">Franchise Set</h2>
              </NavLink>
              <NavLink to="">
              <h2 className="header-title">{packageInfo.packagetype} - {packageInfo.packagetypename}</h2>
              </NavLink>
              <NavLink to="">
                <h2 className="header-title">Franchise Set Information</h2>
              </NavLink>
              <Typography color="textPrimary">Payment</Typography>
            </Breadcrumbs>
        </div>
        <div className="page-container">
          <form noValidate autoComplete="off">
            <MessageBox
              in={showMsgBox}
              content={msgBoxContent}
              type={msgType}
            />
            <Grid
              container
              spacing={2}
              className={classes.root}
              style={{ marginTop: "40px" }}
            >
              <Grid item xs={8}>
                <Card>
                  <CardContent>
                    <h4 className={classes.title}>Payment Transaction</h4>
                    <Grid container spacing={2}>
                      <Grid xs={12}>
                        <Autocomplete
                          value={defaultPayment}
                          options={payment_list}
                          getOptionLabel={(option) => option.description}
                          autoComplete
                          includeInputInList
                          className={classes.autoComplete}
                          name="paymentlist"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="normal"
                              label="Payment Type"
                              variant="outlined"
                              required="true"
                            />
                          )}
                          onChange={(event, newValue) => {
                            if (!newValue == "" || !newValue == null) {
                              setDefaultPayment(newValue);
                              const newData = { ...selectedPayment };
                              newData["paymentid"] = JSON.stringify(
                                newValue.id,
                                null,
                                " "
                              );
                              newData["paymentname"] = newValue.description;
                              setSelectedPayment({ ...newData });
                            }
                          }}
                        />
                        <TextField
                          name="payamount"
                          label="Amount"
                          variant="outlined"
                          type="number"
                          inputProps={{ min: 0, max: 10000 }}
                          margin="normal"
                          required="true"
                          value={selectedPayment.payamount}
                          className={classes.field}
                          onChange={numericOnly}
                          // onKeyPress={NumberKeyTrapper}
                          onCopy={blockEvent}
                          onPaste={blockEvent}
                          onCut={blockEvent}
                        />
                        <TextField
                          name="payref"
                          label="Reference"
                          variant="outlined"
                          type="text"
                          margin="normal"
                          required="true"
                          value={selectedPayment.payref}
                          className={classes.field}
                          onChange={onInputChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid xs={12}>
                      <div className={classes.button}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={onSelectPayment}
                          className={classes.buttonMarginRigh}
                        >
                          Add Payment
                        </Button>
                      </div>
                    </Grid>
                  </CardContent>
                </Card>

                <Grid item xs={12} style={{ marginTop: "20px" }}>
                  <MUIDataTable
                    title={
                      <h4 className={classes.title}>Payment Transaction</h4>
                    }
                    id="table-grid"
                    data={TABLE_DATA}
                    columns={TABLE_COLUMNS}
                    options={TABLE_OPTION}
                  />
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Card>
                  <CardContent>
                    <h4 className={classes.title}>
                      {CurrentPage} Order Summary
                    </h4>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          style={{
                            padding: "10px",
                          }}
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Total Amount To Pay:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(computedPayment.topay_amount).format(
                                  "0,0.00"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box textAlign="right" className={classes.formlabelpayment} >
                                                     <Typography style={{padding:'1px',paddingRight:'3px'}}>Total Amount To Pay:</Typography>
                                                    </Box>  
                                                    <Box textAlign="right" className={classes.formlabelpayment} fontWeight="fontWeightBold">
                                                    <Typography  style={{paddingRight:'4px'}}>{numeral(computedPayment.topay_amount).format('0,0.00')}</Typography>
                                                    </Box> */}
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          style={{
                            padding: "10px",
                          }}
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Total Payment:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(computedPayment.total_payment).format(
                                  "0,0.00"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                          >
                            <Typography
                              style={{ padding: "1px", paddingRight: "3px" }}
                            >
                              Total Payment:
                            </Typography>
                          </Box>
                          <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                            fontWeight="fontWeightBold"
                          >
                            <Typography style={{ paddingRight: "4px" }}>
                              {numeral(computedPayment.total_payment).format(
                                "0,0.00"
                              )}
                            </Typography>
                          </Box> */}
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          style={{
                            padding: "10px",
                          }}
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Shipping:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(
                                  computedPayment.shipping_amount
                                ).format("0,0.00")}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                          >
                            <Typography
                              style={{ padding: "1px", paddingRight: "3px" }}
                            >
                              Shipping:
                            </Typography>
                          </Box>
                          <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                            fontWeight="fontWeightBold"
                          >
                            <Typography style={{ paddingRight: "4px" }}>
                              {numeral(computedPayment.shipping_amount).format(
                                "0,0.00"
                              )}
                            </Typography>
                          </Box> */}
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          style={{
                            padding: "10px",
                          }}
                          variant="outlined"
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Total Balance:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(computedPayment.total_balance).format(
                                  "0,0.00"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                          >
                            <Typography
                              style={{ padding: "1px", paddingRight: "3px" }}
                            >
                              Total Balance:
                            </Typography>
                          </Box>
                          <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                            fontWeight="fontWeightBold"
                          >
                            <Typography style={{ paddingRight: "4px" }}>
                              {numeral(computedPayment.total_balance).format(
                                "0,0.00"
                              )}
                            </Typography>
                          </Box> */}
                        </Paper>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs="12" className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={save_package}
                  disabled={isSaveBtnDisabled}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
            <FranchiseModal
              show={showSavedModal}
              link={propModal[0]}
              caption={propModal[1]}
            />
          </form>
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default FranchisePayment;
